<div class="gpd-inner-page" style="overflow-y: auto !important;">
    <div class="gt-flex-dir-row-rev gt-margin-medium-bottom"
        [style]="'width:100% !important; justify-content:space-between;'">
        <app-search [content]="wikiArticle ?? null" (searchValueChanged)="applyWikiHeadingStyle()"></app-search>
        <div class="article-buttons-container">
            <dx-button i18n-text text="Back" routerLink="/wiki/{{wikiSection}}"
                class="gt-button gt-button-level-1 add-site-icon" icon="back">
            </dx-button>
            <dx-button *ngIf="canEditWiki() && article" i18n-text text="Edit"
                routerLink="/wiki/{{wikiSection}}/{{articleId}}/edit"
                class="gt-button gt-button-level-1 add-site-icon gt-margin-medium-left" icon="edit">
            </dx-button>
        </div>
    </div>
    <div #wikiscrollableDiv class="gt-scrollable-content">

        <div class="wiki-article">
            <div class="gpd-container paragraph-container" [style.overflow]="'unset'">
                <h1 class="wiki-heading"> {{article?.title}}
                </h1>
                <div [ngTemplateOutlet]="contentHeaders"
                    [ngTemplateOutletContext]="{parent: article, level: 1, article: article}">
                </div>
            </div>
            <div #wikiArticle class="article-container">
                <div class=" gpd-container paragraph-container" *ngFor="let paragraph of article?.paragraphs">
                    <div *ngFor="let block of paragraph?.blocks">
                        <p *ngIf="block.type != 'file_group'" [innerHTML]="block.content | safeHTML"> </p>

                        <div *ngIf="block.type == 'file_group'" class="file-group-container">
                            <div *ngFor="let file of block.files" [ngTemplateOutlet]="fileGroupItem"
                                [ngTemplateOutletContext]="{ data: file }">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #contentHeaders let-parent="parent" let-level="level" let-article="article">
        <div *ngFor="let child of parent?.headers">
            <ul class="list-level-{{level}} context-list">
                <li class="">
                    <a class="article-sub-title" class="article-title level-{{level}}"
                        (click)="scrollToElement($safeNavigationMigration(child?.tagId))" [innerHTML]="$safeNavigationMigration(child?.title)">
                    </a>
                    <div class="article-child-container level-{{level+1}}">
                        <div *ngIf="child?.headers.length != 0" class="context-article-heading level-{{level}}"
                            [ngTemplateOutlet]="contentHeaders"
                            [ngTemplateOutletContext]="{parent: child, level: level+1, article: article}">
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </ng-template>

    <ng-template #fileGroupItem let-data="data">
        <div class="file-group-item" (click)="imagePreviewVisible = true; imagePreview = data">
            <p class="file-group-item-content" [innerHTML]="data | safeHTML"></p>
            <dx-button class="file-view-icon" icon="find"
                (onClick)="imagePreviewVisible = true; imagePreview = data"></dx-button>
        </div>
    </ng-template>
</div>

<div class="gpd-well gpd-full-page image-preview-container" *ngIf="imagePreviewVisible">
    <div class="gt-flex-dir-row gt-margin-medium-bottom"
        [style]="'width:100% !important; justify-content:space-between;'">
        <div class="article-buttons-container">
            <dx-button i18n-text text="Back" (onClick)="imagePreviewVisible = false; imagePreview = null"
                class="gt-button gt-button-level-1 add-site-icon" icon="back">
            </dx-button>
        </div>
    </div>
    <div class="image-preview" [innerHTML]="imagePreview | safeHTML"></div>


</div>



<dx-toast [(visible)]="toastVisible" [type]="'success'" i18n-message message="Id copied to clipboard"> </dx-toast>